import TrailPoints from './TrailPoints';

export default TrailPoints;
